import request from '@/utils/request'
export function getPubInfo(data) {
  return request({
    url: '/api/user/pubUserInfo',
    method: 'post',
    data
  })
}
export function getInfo(data) {
  return request({
    url: '/user/uac/userInfo/show',
    method: 'post',
    data
  })
}

export function showShareInfo(data) {
  return request({
    url: '/user/user/user/userUser/showShareInfo',
    method: 'post',
    data
  })
}



export function getUserInfo() {
  return request({
    url: '/user/user/userUser/getUserInfo',
    method: 'post'
    
  })
}


export function showDInfo() {
  return request({
    url: '/user/user/user/userUser/showDInfo',
    method: 'post'
  })
}
export function showUserAddress() {
  return request({
    url: '/user/user/user/userUser/showUserAddress',
    method: 'post'
  })
}
export function changeUserAddress(data) {
  return request({
    url: '/user/user/user/userUser/changeUserAddress',
    method: 'post',
    data
  })
}
export function showXy() {
  return request({
    url: '/user/user/user/userUser/showXy',
    method: 'post'
  })
}
export function showParentInviteCode() {
  return request({
    url: '/user/user/user/userUser/showParentInviteCode',
    method: 'post'
  })
}
export function resetInviteParent(data) {
  return request({
    url: '/user/user/user/userUser/resetInviteParent',
    method: 'post',
    data,
    loading: true
  })
}
export function readIdCard(data) {
  return request({
    url: '/user/user/user/userUser/readIdCard',
    method: 'post',
    data,
    loading: true
  })
}
export function changeUserInfo(data) {
  return request({
    url: '/user/user/user/userUser/changeUserInfo',
    method: 'post',
    data,
    loading: true
  })
}
export function changePwd(data) {
  return request({
    url: '/user/user/user/userUser/changePwd',
    method: 'post',
    data,
    loading: true
  })
}
export function auth(data) {
  return request({
    url: '/user/user/user/userUser/auth',
    method: 'post',
    data,
    loading: true
  })
}
export function update(data) {
  return request({
    url: '/api/user/update',
    method: 'post',
    data,
    loading: true
  })
}
export function inviteChildCount() {
  return request({
    url: '/user/user/userUser/inviteChildCount',
    method: 'post'
  })
}
export function bindInvite(params) {
  return request({
    url: '/user/user/userUser/bindInvite',
    method: 'get',
    params,
    loading: true
  })
}



// WEBPACK FOOTER //
// ./src/api/user/user.js